package com.catbit.opinionpoll.data.models

data class FormUsersLinkerModel(
    val users: List<UserModel>,
    val form: FormModel
)
